export default {
  getDocumentTypeName: (state) => (type) => state.documentTypes.find((d) => d.type === type)?.text,
};
